import { FC, useState } from 'react';
import { MenuItem, Grid } from '@mui/material';
import { IDropdownResponse, IOrderStatus, IPeople } from '../../../models';
import {
  FiltersButtons,
  FiltersLayout,
  NeighborhoodDropdown,
  NeighborhoodLotsDropdown,
  SMBSelect
} from '../../../components';

interface IManageBuildsFilters {
  isLoading: boolean;
  isLoadingAgents: boolean;
  applyFilters: (clearFilters?: boolean) => void;
  selectedStatus: string;
  selectedAgent: string;
  setSelectedStatus: (val: string) => void;
  setSelectedAgent: (val: string) => void;
  handleSearch: (clearSearch?: boolean) => void;
  statuses: IOrderStatus[] | null;
  agents: IPeople[] | null;
  isLoadingStatuses: boolean;
  setSelectedNeighborhoodId: (val: string) => void;
  setSelectedLotId: (val: string) => void;
  selectedLotId: string | number;
  selectedNeighborhoodId: string;
  selectedAlert: string;
  setSelectedAlert: (val: string) => void;
  setSelectedJobType: (val: string) => void;
  selectedJobType: string;
  alertStatuses: IDropdownResponse[] | null;
  isLoadingAlertStatuses: boolean;
}

export const ManageBuildsFilters: FC<IManageBuildsFilters> = ({
  isLoading,
  applyFilters,
  selectedStatus,
  setSelectedStatus,
  selectedNeighborhoodId,
  selectedLotId,
  setSelectedNeighborhoodId,
  setSelectedLotId,
  statuses,
  isLoadingStatuses,
  isLoadingAgents,
  agents,
  selectedAgent,
  setSelectedAgent,
  selectedAlert,
  setSelectedAlert,
  alertStatuses,
  isLoadingAlertStatuses,
  setSelectedJobType,
  selectedJobType
}) => {
  const [hasAppliedFilters, setHasAppliedFilters] = useState<boolean>(false);

  return (
    <FiltersLayout>
      <Grid item xs={12} sm={6} md={3}>
        <NeighborhoodDropdown
          value={selectedNeighborhoodId}
          handleChange={value => setSelectedNeighborhoodId(value.toString())}
          isAdminPortal={true}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <NeighborhoodLotsDropdown
          value={selectedLotId}
          handleChange={value => setSelectedLotId(value.toString())}
          isDisabled={!selectedNeighborhoodId}
          apiParams={{ neighborhoodId: selectedNeighborhoodId }}
          isAdminPortal={true}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <SMBSelect
          disabled={isLoadingStatuses}
          name="status"
          variant="outlined"
          label={isLoadingStatuses ? 'Loading...' : 'Status'}
          handleClear={() => setSelectedStatus('')}
          value={selectedStatus}
          onChange={({ target: { value } }) => setSelectedStatus(value as string)}
        >
          {statuses &&
            statuses.map((status, index) => {
              return (
                <MenuItem key={`${index}`} value={status.value}>
                  {status.description}
                </MenuItem>
              );
            })}
        </SMBSelect>
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <SMBSelect
          disabled={isLoadingAlertStatuses}
          name="alert"
          variant="outlined"
          label={isLoadingAlertStatuses ? 'Loading...' : 'Alert Status'}
          handleClear={() => setSelectedAlert('')}
          value={selectedAlert}
          onChange={({ target: { value } }) => setSelectedAlert(value as string)}
        >
          {alertStatuses?.map((status, index) => {
            return (
              <MenuItem key={`${index}`} value={status.value}>
                {status.description}
              </MenuItem>
            );
          })}
        </SMBSelect>
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <SMBSelect
          disabled={isLoading}
          name="agent"
          label={isLoading ? 'Loading...' : 'Build Type'}
          variant="outlined"
          handleClear={() => setSelectedJobType('')}
          value={selectedJobType}
          onChange={({ target: { value } }) => setSelectedJobType(value as string)}
        >
          <MenuItem value="Presale">Presale</MenuItem>
          <MenuItem value="Spec">Spec</MenuItem>
        </SMBSelect>
      </Grid>

      <Grid item xs={12} md={5}>
        <FiltersButtons
          hasAppliedFilters={hasAppliedFilters}
          isDisabled={isLoading}
          handleApplyFilters={() => {
            setHasAppliedFilters(true);
            applyFilters();
          }}
          handleResetFilters={() => {
            setHasAppliedFilters(false);
            // setSearchValue('');
            setSelectedNeighborhoodId('');
            setSelectedLotId('');
            setSelectedAgent('');
            setSelectedStatus('');
            setSelectedAlert('');
            setSelectedJobType('');
            applyFilters(true);
          }}
        />
      </Grid>
    </FiltersLayout>
  );
};
